// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:49.217037
var courses = [
    {
        "course_id": "E2D53E3C-2748-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: Multi-Dose Vial Infection Prevention Practices (Free)",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nMulti-dose vials efficiently deliver important medications and vaccines to clinics, hospitals, and other healthcare settings in large volumes. As a nurse, you need to understand how to mitigate the risks associated with this packaging to prevent infections.\r\nWhy is this course important to you?\r\nMulti-dose vials are more susceptible to contamination when compared to single-dose vials. This is because multi-dose vials contain more than one dose of a medication, may be used for more than one person, and are accessed multiple times to draw doses of a medication. Each entry into the vial increases the risk of carrying pathogens into the medication or solution. If the multi-dose vial becomes contaminated, pathogens may easily spread from one person to the next person. To keep patients safe, there are important infection control steps to take when using multi-dose vials.",
        "learning_objectives_html": "At the conclusion, participants should be able to:<br />\r\n<br />\r\nDifferentiate between a single-dose vial and a multi-dose vial.<br />\r\n<br />\r\nDescribe five (5) CDC best practices for infection prevention when using multi-dose vials.",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "306B4D00-C749-E611-832F-005056B17E48",
                "course_category_name": "Environmental Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01DE6ED9-D88C-EB11-80DF-005056B134EC",
                "course_category_name": "Hand Hygiene",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Infection Control",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.3,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];